import React, { FC } from "react";

type IProps = {
  width?: string;
  height?: string;
  color?: string;
};

const PauseMain: FC<IProps> = ({ width, height, color }) => {
  return (
    <svg
      width={width ? width : "56"}
      height={height ? height : "56"}
      viewBox="0 0 56 56"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_799_1726)">
        <circle cx="28" cy="28" r="26" fill="#FD8533" />
        <rect
          x="8"
          y="8"
          width="40"
          height="40"
          rx="20"
          fill="white"
          fill-opacity="0.88"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M23.625 19.25C22.5895 19.25 21.75 20.0895 21.75 21.125V34.875C21.75 35.9105 22.5895 36.75 23.625 36.75C24.6605 36.75 25.5 35.9105 25.5 34.875V21.125C25.5 20.0895 24.6605 19.25 23.625 19.25ZM32.375 19.25C31.3395 19.25 30.5 20.0895 30.5 21.125V34.875C30.5 35.9105 31.3395 36.75 32.375 36.75C33.4105 36.75 34.25 35.9105 34.25 34.875V21.125C34.25 20.0895 33.4105 19.25 32.375 19.25Z"
          fill="#FD8533"
        />
      </g>
      <defs>
        <clipPath id="clip0_799_1726">
          <rect width="56" height="56" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default PauseMain;
